import React from 'react';
import { DialogProps, useMediaQuery } from '@material-ui/core';
import { BoolControl } from '@domain/hooks/use.bool';
import { DialogContext } from '@components/dialog/dialog.context';
import { StyledDialog } from '@components/dialog/main.dialog.styles';

export interface MainDialogProps extends Omit<DialogProps, 'open'> {
  open: BoolControl;
}

export const MainDialog = ({ open, ...rest }: MainDialogProps) => {
  const fullScreen = useMediaQuery('(max-width:600px)');
  return (
    <DialogContext.Provider value={{ onClose: open.disable }}>
      <StyledDialog open={open.enabled} onClose={open.disable} fullScreen={fullScreen} fullWidth {...rest} />
    </DialogContext.Provider>
  );
};
